import { render } from "./SelectHandler.vue?vue&type=template&id=1b9a4550"
import script from "./SelectHandler.vue?vue&type=script&lang=js"
export * from "./SelectHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__